import { Stack, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useLocation } from 'react-router-dom';
import LinkedInFollowButton from '../../components/LinkedInFollowButton';
import logo from '../../lib/logo.png';

const RegisterCompletePage = () => {
  const theme = useTheme();
  const { state } = useLocation();
  const registrationNotes: string | undefined = state?.registrationNotes;
  return (
    <Stack
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
      }}
    >
      <Typography
        sx={{
          fontFamily: 'Raleway',
          textAlign: 'center',
          color: theme.palette.primary.main,
        }}
        color={'primary'}
        variant="h3"
      >
        Thank you for registering!
      </Typography>
      {registrationNotes && (
        <Typography
          sx={{ textAlign: 'center', marginLeft: 10, marginRight: 10 }}
          variant="body1"
          dangerouslySetInnerHTML={{ __html: registrationNotes }}
        />
      )}
      <Box alignItems={'center'} display={'flex'} flexDirection={'column'}>
        <Typography
          sx={{
            fontFamily: 'Raleway',
            color: theme.palette.primary.main,
          }}
          color={'primary'}
          variant="h5"
        >
          Follow us on LinkedIn!
        </Typography>
        <LinkedInFollowButton companyId="10516378" />
      </Box>
      <a href="https://sketchdev.io">
        <img height={75} src={logo} alt="Sketch" />
      </a>
    </Stack>
  );
};

export default RegisterCompletePage;
